import React, { useState } from 'react';
import LoadingPage from '../../reusableComponents/loader/loadingPage';
import NoDataFound from '../../utilsComponent/noDataFound';
import DocumentSliderModal from '../../utilsComponent/DocumentSliderModal';
import "../documentsIAGRI/PolicyDocumentsSection.scss" 
import { groupDocumentsByType } from '../../utilFunctions';

const PolicyDocumentsSection = ({ documents=[], isLoadingDocuments }) => {
    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [currentGroupDocs, setCurrentGroupDocs] = useState([]);

    const groupedDocs = groupDocumentsByType(documents);

    const openDocumentSlider = (docs) => {
        setCurrentGroupDocs(docs);
        setCurrentSlideIndex(0); // Start from first document in group
        setIsSliderOpen(true);
    };

    const onSliderClose = () => {
        setIsSliderOpen(false);
        setCurrentGroupDocs([]);
        setCurrentSlideIndex(0);
    };

    return (
        <>
            <div className='policy-documents-section'>
                {isLoadingDocuments ? (
                    <LoadingPage />
                ) : documents.length > 0 ? (
                    <div className='documents-table-container'>
                        <table className='documents-table'>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Type</th>
                                    <th>Document Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(groupedDocs).map((type, index) => (
                                    <tr key={type}>
                                        <td>{index + 1}</td>
                                        <td>{type}</td>
                                        <td
                                            onClick={() => openDocumentSlider(groupedDocs[type])}
                                            className="document-link text-primary"
                                        >
                                            View {groupedDocs[type]?.length > 1 ? `${groupedDocs[type].length} ` : ''} 
                                                {type} Document{groupedDocs[type]?.length > 1 ? 's' : ''}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoDataFound text="No Policy Document Found." />
                )}
            </div>

            {isSliderOpen && (
                <DocumentSliderModal
                    currentIndex={currentSlideIndex}
                    setCurrentIndex={setCurrentSlideIndex}
                    onClose={onSliderClose}
                    documents={currentGroupDocs} // Pass all docs of selected type
                    show={isSliderOpen}
                    singleView={false} //  Allow navigation within group
                />
            )}
        </>
    );
};

export default PolicyDocumentsSection;
